import { Modal, Radio, Typography } from "antd";
import { useEffect, useState } from "react";
import { cancelarAssinaturaService } from "../services/cancelarAssinaturaService";

type ModalCancelarAssinaturaProps = {
  isModalOpen: boolean;
  handleFechar: () => void;
  assinaturaId: number | null;
  onCancelamentoConcluido: () => Promise<unknown> | void;
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
};

const getErrorMessage = (error: unknown) => {
  const backendMessage = (error as any)?.response?.data?.message;

  if (Array.isArray(backendMessage) && backendMessage.length > 0) {
    return backendMessage[0];
  }

  if (typeof backendMessage === "string") {
    return backendMessage;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "Não foi possível cancelar a assinatura.";
};

export default function ModalCancelarAssinatura({
  isModalOpen,
  handleFechar,
  assinaturaId,
  onCancelamentoConcluido,
  showSuccess,
  showError,
}: ModalCancelarAssinaturaProps) {
  const [inativarAnuncios, setInativarAnuncios] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      setInativarAnuncios(true);
    }
  }, [isModalOpen]);

  const handleCancelarAssinatura = async () => {
    if (!assinaturaId) {
      showError("Não foi possível identificar a assinatura selecionada.");
      return;
    }

    setIsLoading(true);

    try {
      await cancelarAssinaturaService(assinaturaId, inativarAnuncios);
      showSuccess("Assinatura cancelada com sucesso!");
      handleFechar();
      await onCancelamentoConcluido();
    } catch (error) {
      showError(getErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      title="Cancelar assinatura"
      onCancel={handleFechar}
      cancelText="Voltar"
      okText="Cancelar assinatura"
      onOk={handleCancelarAssinatura}
      confirmLoading={isLoading}
      okButtonProps={{ danger: true }}
    >
      <Typography.Paragraph>
        Tem certeza que deseja cancelar esta assinatura?
      </Typography.Paragraph>
      <Typography.Paragraph>
        Quando deseja inativar os anúncios vinculados?
      </Typography.Paragraph>
      <Radio.Group
        value={inativarAnuncios}
        onChange={(event) => setInativarAnuncios(event.target.value)}
      >
        <Radio value={true}>Inativar os anúncios agora</Radio>
        <Radio value={false}>
          Manter os anúncios ativos até o fim do período da assinatura
        </Radio>
      </Radio.Group>
    </Modal>
  );
}
